type Listener<T> = (value: T, prevValue: T) => void

export class ObservableValue<T> {
  private _value: T
  private listeners: Array<Listener<T>> = []

  constructor(value: T) {
    this._value = value
  }

  public get value(): T {
    return this._value
  }

  public set value(value: T) {
    if (this._value !== value) {
      const prevValue = this._value
      this._value = value
      this.notify(value, prevValue)
    }
  }

  public subscribe(callback: Listener<T>): () => void {
    this.listeners.push(callback)
    return () => this.unsubscribe(callback)
  }

  public unsubscribe(callback: Listener<T>): void {
    this.listeners = this.listeners.filter((cb) => cb !== callback)
  }

  private notify(value: T, prevValue: T) {
    for (const listener of this.listeners) {
      listener(value, prevValue)
      if (value !== this._value) {
        break
      }
    }
  }
}
